import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";

import { Select2ApplyBar, Select2MenuItem } from "~/components/select2";
import { StatusChip } from "~/components/status_chip";

import type { StatusOption } from "./transactionFilterUtils";

export interface StatusFilterPopoverProps {
  mode: "include" | "exclude";
  options: StatusOption[];
  initialSelected: string[];
  initialExclude: string;
  onApply: (selected: string[], exclude: string) => void;
  onClose: () => void;
}

export function StatusFilterPopover({
  mode,
  options,
  initialSelected,
  initialExclude,
  onApply,
  onClose,
}: StatusFilterPopoverProps) {
  const theme = useTheme();
  const [selected, setSelected] = useState(initialSelected);
  const [exclude, setExclude] = useState(initialExclude);

  const toggleCode = (code: string) =>
    setSelected((prev) =>
      prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code],
    );

  const apply = () => {
    onApply(selected, exclude);
    onClose();
  };

  return (
    <Stack>
      <Stack sx={{ maxHeight: 320, overflow: "auto" }}>
        {options.map((opt) =>
          mode === "include" ? (
            <Select2MenuItem
              key={opt.code}
              label={
                <StatusChip
                  label={opt.label}
                  color={opt.color ?? theme.palette.primary.main}
                />
              }
              selected={selected.includes(opt.code)}
              onClick={() => toggleCode(opt.code)}
            />
          ) : (
            <Select2MenuItem
              key={opt.code}
              label={
                <StatusChip
                  label={opt.label}
                  color={opt.color ?? theme.palette.primary.main}
                />
              }
              selected={opt.code === exclude}
              onClick={() => setExclude(opt.code === exclude ? "" : opt.code)}
            />
          ),
        )}
      </Stack>
      <Select2ApplyBar onApply={apply} />
    </Stack>
  );
}
